export const revoke = token =>
  fetch(`${process.env.REACT_APP_API_HOST}/oauth/revoke`, {
    method: 'POST',
    credentials: 'include',
    body: `token=${encodeURIComponent(token)}}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })

export const isValid = payload =>
  Boolean(payload) && Boolean(payload.access_token) && !isExpired(payload)

// `created_at` is seconds since epoch.
const isExpired = ({ created_at, expires_in }) =>
  created_at + expires_in < Date.now() / 1000



// WEBPACK FOOTER //
// ./src/utils/token.js